export class MortgageReportsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getMortgageCallReport(params) {
    return this.#http.get('/api/GenerateMcr', { params });
  }

  async getMcrPreview(params) {
    return this.#http.get('/api/McrPreview', { params });
  }

  async getHmdaLarPreview(params) {
    return this.#http.get('/api/HmdaLarPreview', { params });
  }

  async getHmdaLarValidation(params) {
    return this.#http.get('/api/HmdaLarValidation', { params });
  }

  async getHmdaLarFile(params) {
    return this.#http.get('/api/GenerateHmdaLar', { params });
  }
}
